import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mantine/core';

import { Modal, Text } from 'components';
import { DialogData } from 'types';
import { AppUtils } from 'utils';
import { IRootState } from 'config/redux';
import { removeDialog } from 'config/redux/slice';

const DialogListener = () => {

  const dialogState = useSelector((state: IRootState) => state.dialog.data);
  const dispatch = useDispatch();
  const [visibleObject, setVisibleObject] = useState<DialogData | undefined>(undefined);
  const [reload, setReload] = useState<number>(0);

  const modals = useRef<DialogData[]>([]);

  const onDismiss = useCallback(() => {
    if (modals.current[0]?.onClose) {
      modals.current[0].onClose();
    }
    modals.current.splice(0, 1);
    setReload(old => old + 1);
    setTimeout(() => dispatch(removeDialog()), 500);
  }, []);

  useEffect(() => {
    if (AppUtils.isEmpty(dialogState)) {
      return;
    }
    if (modals.current.length > 0) {
      modals.current = [];
      setVisibleObject(undefined);
    }
    modals.current = [...modals.current, { ...dialogState! }];
    setReload(old => old + 1);
  }, [dialogState]);

  useEffect(() => {
    setVisibleObject(modals.current && modals.current.length > 0 ? modals.current[0] : undefined)
  }, [reload]);

  return (
    <Modal
      opened={!!visibleObject}
      onClose={onDismiss}
      withCloseButton={true}
      size={'lg'}
    >
      <Box ta={'center'} mb={'lg'} mx={'md'}>
        <Text fz={'h4'} ta={'center'} fw={600}>{visibleObject?.title}</Text>
        <Text fz={'h5'} ta={'center'} my={'lg'}>{visibleObject?.description}</Text>
      </Box>
    </Modal>
  )
}

export default DialogListener